import React from 'react';
import classnames from 'classnames';

class SelectOccupationRating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      occupationalRating: this.props.occupationalRating
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    if (this.props.onChange) {
			this.props.onChange(e.target.value);
		}
    this.setState({
      occupationalRating: e.target.value
    });
  }

  render() {

    let nodes = this.props.items.map((items, index) => {
      return (
      <li key={index}>
        <input
          id={this.props.name + index}
          className={classnames('', {active: this.state.occupationalRating == items.value})}
          type="radio"
          onChange={this.handleChange}
          value={items.value}
          name={this.props.name}
          defaultChecked={items.defaultChecked}
        />
        <label className={classnames('labelButton', {active: this.state.occupationalRating == items.value})} htmlFor={this.props.name + index}>{items.label}</label>
      </li>
    );
    });

    return (
      <div className="select-rating">
      <p>Please ensure you select the correct rating, otherwise your premium estimate may be incorrect.</p>
      <p>My occupational rating with QSuper is: </p>
        <ul className="radio-inputs">
          {nodes}
        </ul>
      </div>
        );
  }
}

SelectOccupationRating.defaultProps = {
  name: 'name',
    items: [
      {value: "High risk", label: "High Risk"},
      {value: "Standard", label: "Standard"},
      {value: "White collar", label: "White Collar"},
      {value: "Professional", label: "Professional"}
    ],
    onChange: function(){},
    occupationalRating: ''
};

SelectOccupationRating.propTypes = {
  // items : React.PropTypes.array.isRequired,
  // onChange: React.PropTypes.func.isRequired,
  // occupationalRating: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired
};

export default SelectOccupationRating;



// WEBPACK FOOTER //
// ./src/components/forms/SelectOccupationRating.js